var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-none-more"},[_vm._v("\n  手机端最多显示本场直播打赏最多的5位达人\n")])}
var staticRenderFns = []

export { render, staticRenderFns }